import { Box } from '@mui/material';

import {
  formatMetarAltimeter,
  formatMetarClouds,
  formatMetarElevation,
  formatMetarObservationTime,
  formatMetarPrecipitation,
  formatMetarSeaLevelPressure,
  formatMetarTemperature,
  formatMetarVisibility,
  formatMetarWeather,
  formatMetarWind,
} from '../lib';

import { aircraftDrawerLocationClasses } from './aircraftDrawerWeatherClasses';

import type { AirMetar } from '#entities';

export const MetarDetail = ({ metar }: { metar: AirMetar }) => {
  const observationTime = formatMetarObservationTime(metar);
  const windFormatted = formatMetarWind(metar);
  const visibilityFormatted = formatMetarVisibility(metar);
  const clouds = formatMetarClouds(metar);
  const weather = formatMetarWeather(metar);
  const temperature = formatMetarTemperature(metar);
  const altimeter = formatMetarAltimeter(metar);
  const seaLevelPressure = formatMetarSeaLevelPressure(metar);
  const precipitation = formatMetarPrecipitation(metar);
  const elevation = formatMetarElevation(metar);

  return (
    <Box className={aircraftDrawerLocationClasses.forecastFields}>
      {observationTime ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Observed
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {observationTime}
            {metar.metarType ? ` (${metar.metarType})` : ''}
          </Box>
        </Box>
      ) : null}
      {windFormatted ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Winds
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {windFormatted}
          </Box>
        </Box>
      ) : null}
      {visibilityFormatted ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Visibility
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {visibilityFormatted}
          </Box>
        </Box>
      ) : null}
      {weather ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Weather
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {weather}
          </Box>
        </Box>
      ) : null}
      {clouds.length > 0 ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Clouds
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {((text: string) => {
              if (!text) {
                return '';
              }
              return [...text][0].toUpperCase() + [...text].slice(1).join('');
            })(clouds.map(({ formatted }) => formatted).join(', '))}
            .
          </Box>
        </Box>
      ) : null}
      {temperature ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Temperature
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {temperature}
          </Box>
        </Box>
      ) : null}
      {altimeter ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Altimeter
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {altimeter}
          </Box>
        </Box>
      ) : null}
      {seaLevelPressure ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Sea Level Pressure
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {seaLevelPressure}
          </Box>
        </Box>
      ) : null}
      {precipitation ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Precipitation
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {precipitation}
          </Box>
        </Box>
      ) : null}
      {elevation ? (
        <Box className={aircraftDrawerLocationClasses.forecastField}>
          <Box className={aircraftDrawerLocationClasses.forecastFieldLabel}>
            Elevation
          </Box>
          <Box className={aircraftDrawerLocationClasses.forecastFieldValue}>
            {elevation}
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};
